<icon-triggered-context-menu
    *ngIf="hasMenu"
    [menu-items]="menuItems">
</icon-triggered-context-menu>
